import { defineMessages } from 'react-intl';

export default defineMessages({
     removeInfo: {
        id: 'quoteandbind.PPRLinedirectives.templates.PersonalUmbrella.Remove Property',
        defaultMessage: 'Remove Property',
    },
    removeInfoDesc: {
        id: 'quoteandbind.PPRLinedirectives.templates.PersonalUmbrella.Property',
        defaultMessage: 'Are you sure you want to remove this Property from the list?',
    }
});